import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../../../services/print.service';
import { CreditCardStorageSettingsService } from 'app/services/credit-card-storage-settings.service';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'print-payment-step',
  styleUrls: ['../../wizard/wizard.component.scss'],
  templateUrl: './printPaymentStep.component.html',
})
export class PrintPaymentStepComponent implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() next;
  @Input() prev;
  @Input() paymentStepView;
  @Input() setPaymentStepView;

  cards = [];
  storyId;

  constructor(
    public printService: PrintService,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute,
    private creditcardStorageSettingsService: CreditCardStorageSettingsService
  ) {}

  ngOnInit() {
    this.loadPaymentMethods();
    this.storyId = this.activatedRoute.snapshot.params.id;
  }

  submit() {
    this.firebaseService.logEvent('checkout_book_format_select', {
      book_format_id: this.printService.specs.book_format_id,
      story_id: this.storyId,
      project_id: this.printService.projectId,
      currency: this.printService.bookformats.find(
        bookformat => bookformat.id === this.printService.specs.book_format_id
      ).currency,
      product_price: this.printService.bookformats.find(
        bookformat => bookformat.id === this.printService.specs.book_format_id
      ).book_price,
    });
    this.prev();
  }

  preselectCard() {
    if (!this.cardSelected() && this.cards.length) {
      this.selectCard(this.cards[0]);
    }
  }

  selectCard(card) {
    this.printService.selectedCard = card;
    this.printService.specs.payment_method_id = card.token;
    this.firebaseService.meta.paymentMethod = card.card_type;
  }

  submitCard(card, saveForFuture) {
    this.selectCard(card);
    this.submit();
    this.creditcardStorageSettingsService.update({ saveCards: saveForFuture });
  }

  cardSelected() {
    return !!this.printService.specs.payment_method_id;
  }

  addCard() {
    this.setPaymentStepView('add');
  }

  showList() {
    this.setPaymentStepView('list');
    this.printService.getPaymentMethods().subscribe(data => {
      this.cards = data['results'];
      this.preselectCard();
    });
  }

  loadPaymentMethods() {
    this.printService.getPaymentMethods().subscribe(data => {
      this.cards = data['results'];
      this.preselectCard();
      if ((!this.paymentStepView && !this.cards.length) || this.paymentStepView === 'add' ) {
        this.addCard();
      } else {
        this.setPaymentStepView('list');
      }
    });
  }
}
